module.exports = __webpack_public_path__ + "media/country_flags/om-93a04b03.png";